import {
  Button,
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Modal,
  Typography,
  styled,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import ValueCalculator from "../ValueCalculator";
import Swipper from "../Swipper";

interface IAccessory {
  id: number;
  img?: string;
  name: string;
  brand: string;
  price: number;
  folder: string;
}

const TypographyCentered = styled(Typography)`
    align: center;
  `;


const Accessory: React.FC<IAccessory> = ({ id, img, name, brand, price, folder }) => {
  const { t } = useTranslation();
  const images = img?.length ? img?.split(",").map((path) => { return `Accessories/${folder}/${path.trim()}` }) : ["NoImage.jpg"];
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [value, setValue] = useState(0);

  useEffect(() => {
    (async () => {
      const dolarPrice: number = await ValueCalculator(price);
      setValue(dolarPrice as number)
    })()
  });

  return (
    <>
      <Card sx={{ maxWidth: 345, minWidth: "100%" }} key={id}>
        <CardMedia
          key={images[0]}
          sx={{
            padding: "1em 1em 0 1em",
            objectFit: "contain"
          }}
          component="img"
          height={240}
          width={345}
          title="accessory"
          image={require(`../../Assets/${images[0].trim()}`)}
          onClick={handleOpen}
          loading="lazy"
        ></CardMedia>
        <CardContent sx={{ minHeight: 210 }}>
          <Typography gutterBottom variant="h5" component="p" align="center">
            {name}
          </Typography>
          <TypographyCentered>{brand}</TypographyCentered>
        </CardContent>
        <CardActions>
          <ButtonGroup orientation="vertical" fullWidth>
            <TypographyCentered variant="subtitle1" border={2}>
              ${value}
            </TypographyCentered>
            <Button variant="contained" size="small" onClick={() => window.open(`https://wa.me/5493513901837?text=${encodeURIComponent(`${t("common.buy_message")}: \n 
            ${t("common.accessory")} ${name} - $${value}`)}&attachment=${encodeURIComponent(`Accessories/${folder}/${images[0].trim()}`)}`)}>
              {t("common.buy")}
            </Button>
          </ButtonGroup>
        </CardActions>
      </Card>
      <Modal open={open}>
        <>
          <Swipper images={images} size={{ height: "550vw", width: "100vw" }} onImageClick={() => { return null; }} close={handleClose}></Swipper>
        </>
      </Modal>
    </>
  );
};

export type { IAccessory };
export default React.memo(Accessory);